import { Divider, Stack, Typography, useTheme } from '@mui/material';
import { NavbarAdminMainButton } from './NavbarAdminMainButton';
import { featureConfig, organizationConfig } from 'src/layouts/dashboard/navbar/config';
import { NavbarAdminCollapseButton } from 'src/layouts/dashboard/navbar/admin/NavbarAdminCollapseButton';
import { NavbarAdminSubButton } from 'src/layouts/dashboard/navbar/admin/NavbarAdminSubButton';
import { ContractPlan } from 'src/API';
import { useOrganization } from 'src/contexts/OrganizationContext';

export const NavbarAdminContents = () => {
  const { organization, isLoading } = useOrganization();
  const theme = useTheme();

  // ローディング中またはorganizationがない場合は何も表示しない
  if (isLoading || !organization) {
    return null;
  }

  const oneOnOneFeatureConfig = featureConfig.filter((c) => c.title !== '評価');
  const customAdminNavbar = (data = featureConfig) =>
    data.map((config) => {
      if (config.configs.length === 1) {
        const item = config.configs[0];
        return <NavbarAdminMainButton key={item.id} title={item.title} href={item.href} />;
      }
      return (
        <NavbarAdminCollapseButton key={config.id} config={config}>
          <Stack gap="10px">
            {config.configs.map((item) => (
              <NavbarAdminSubButton key={item.id} title={item.title} href={item.href} />
            ))}
          </Stack>
        </NavbarAdminCollapseButton>
      );
    });
  return (
    <Stack gap="8px">
      <Typography variant="titleM" color={theme.palette.text.contrast} pt="8px">
        組織設定
      </Typography>
      {organizationConfig.map((item) => (
        <NavbarAdminMainButton key={item.id} title={item.title} href={item.href} />
      ))}
      <Divider />
      <Typography variant="titleM" color={theme.palette.text.contrast} pt="8px">
        機能設定
      </Typography>
      <Stack gap="4px">
        {organization.contractPlan === ContractPlan.OneOnOne
          ? customAdminNavbar(oneOnOneFeatureConfig)
          : customAdminNavbar()}
      </Stack>
    </Stack>
  );
};
